import React from 'react'
import { MaskField } from "react-mask-field";
export default function PhoneInput({ value, onChange,placeholder,readOnly }) {
    return (
        <>
            <MaskField
                className="form-control"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                mask="____-_______"
                showMask
                replacement={{ _: /\d/ }}
                readOnly={readOnly}
            />
        </>
    )
}
